export default "__VITE_ASSET__41b23979__"